<template>
  <div class="welcome">
    <img v-if="showDiscountWelcomeImage" class="image-container" :src="require('@/assets/onboarding-discount.png')">
    <img v-else class="image-container" :src="require('@/assets/introduction/kikar-header.svg')">
    <div class="page-content">
      <div class="description">
        <div class="title">{{  title }}</div>
        <div class="subtitle">נעים מאוד, נתחיל עם <span class="bold">4 שאלות</span> שיעזרו לנו להכיר אותך טוב יותר.</div>
      </div>
      <div class="bottom-page">
        <div class="button-container">
          <riseup-button class="button-to-signup" :title="'אפשר להתחיל'" :size="'small'" :action="goToLQ"/>
        </div>
        <div class="already-registered">
          כבר הצטרפת לשירות?
          <span class="enter" v-on:click="goToHome">הכניסה מכאן</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import router from '../../../../router';
import Segment from '../../../../Segment';
import config from '../../../../config';
import questions from './lead-qualification/consts/questions';

export default {
  name: 'Welcome',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  props: {
    referralData: {
      type: Object,
    },
  },
  created() {
    const utmParams = _.pickBy(this.$route.query, (v, k) => k.startsWith('utm_'));
    Segment.trackUserGot('SignupEntered', { ...utmParams });
    Segment.trackUserGotToPixel('SE');
    this.setUtmParams(utmParams);
    this.saveReferrer(utmParams, this.referralData);
  },
  computed: {
    showDiscountWelcomeImage() {
      return this.$route.query.utm_source === 'Discount_app';
    },
    title() {
      if (this.referralData) {
        const { householdName } = this.referralData;
        return `אלפי לקוחות כבר מנצחים את החודש עם riseup. ${householdName} כבר בפנים, עכשיו תורך!`;
      }
      return 'אלפי לקוחות כבר מנצחים את החודש עם riseup. עכשיו תורך!';
    },
  },
  methods: {
    ...mapActions('signup', ['setUtmParams']),
    async goToLQ() {
      Segment.trackUserInteraction('SignupClicked');
      Segment.trackUserInteractionToPixel('SC');
      router.push({ path: `signup/lq/question/${questions.QUESTION_NAMES.FINANCIAL_CONTROL}` });
    },
    async goToHome() {
      router.push({ path: '/sr' });
    },
    saveReferrer(utmParams) {
      if (utmParams.utm_term) {
        localStorage.setItem('riseup.utm_referrer_eoy', utmParams.utm_term);
      }
      if (this.referralData) {
        const { cookieDomain } = config.get();
        this.$cookies.set('referralToken', this.referralData.referralToken, '30d', '/', cookieDomain, true, true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../scss/mixins';

  .welcome {
    @include white-page-frame;
    height: 100%;

    .image-container {
      width: 100%;
    }

    .page-content {
      @include responsive-padding;
      margin-top: 30px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .description {
        .title {
          font-size: 22px;
          line-height: 1.27;
          width: 100%;
          margin-bottom: 15px;
          font-weight: bold;
        }

        .subtitle {
          font-size: 18px;
          line-height: 1.5;

          .bold {
            font-weight: bold;
          }
        }
      }

      .button-container {
        @include responsive-padding-top-bottom;

        .button-to-signup {
          width: 100%;
          white-space: nowrap;
        }
      }

      .already-registered {
        margin-bottom: 30px;
        color: $riseup_light_blue;
        text-align: center;

        .enter {
          font-weight: bold;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }

</style>
